// JS-rendering crawlers keep no localStorage, so the hourly heartbeat throttle
// never suppresses them. Only named crawlers that self-identify in their user
// agent match: generic tokens (bot, headless) and navigator.webdriver would
// also catch a publisher's own automated or headless test of their install,
// which the heartbeat must record. Names are the crawlers seen in
// smbe.ezoic.com access logs.
const CRAWLER_UA = /bingbot|meta-webindexer|meta-externalagent|meta-externalads|baiduspider|yahoo! slurp|yisouspider|sogou web spider|ahrefsbot|ahrefssiteaudit|amazonbot|amzn-searchbot|yandexbot|yandexrenderresourcesbot|seekportbot|sincerasyntheticuser|storebot-google/i;

export function isKnownCrawler(userAgent: string = navigator.userAgent): boolean {
  return CRAWLER_UA.test(userAgent || '');
}
